import React, { useState, useEffect, useContext, useRef } from "react";
import styled from "styled-components";
import { useSpring, animated } from "react-spring";

import { Layout, Settings } from "../interfaces/layout";
import {
    SlideContainer,
    SlideTitle,
    Subtitle,
} from "../components/slideComponents";
import { SequencedVideo } from "../components/SequencedVideo";
import { RenderContentBlock } from "../components/RenderContentBlock";
import MicrositeContext from "../MicrositeContext";
import { getCompletedTransitionNames } from "../micrositeFunctions";

const StyledSlideTitle = styled(SlideTitle)`
    display: ${(props) => (props.hidden ? "none" : "flex")};
    flex: 0;
`;

const SlideColumn = styled.div<SlideColumnProps>`
    overflow-wrap: break-word;

    width: ${(props) => props.width};
    padding-top: ${(props) => props.paddingTop};
`;

const LeftContentSequencedVideo = ({
    settings,
    content,
    transitions,
    disableSequencing,
    pageName,
    groupName,
}: Layout) => {
    let {
        navigationDispatch,
        navigationState: { currentTransitionIndex },
        editing,
        slideSize,
        globalTheming,
        currentPageConfig,
    } = useContext(MicrositeContext);

    if (editing || disableSequencing) {
        currentTransitionIndex = 1;
    }
    const transitionNamesComplete = getCompletedTransitionNames(
        transitions,
        currentTransitionIndex
    );
    const currentTransitionObject =
        transitions[
            currentTransitionIndex === 0 ? 0 : currentTransitionIndex - 1
        ];
    const highlightColor = settings.highlightColor
        ? settings.highlightColor
        : globalTheming?.highlightColor;

    return (
        <SlideContainer
            settings={settings}
            slideWidth={slideSize?.width}
            slideHeight={slideSize?.height}
            fontSize={slideSize?.fontSize}
        >
            <SequencedVideo
                isCurrent={
                    currentTransitionObject &&
                    currentTransitionObject.name === "sequenced_video"
                }
                disableSequencing={!!(editing || disableSequencing)}
                setup={content.sequenced_video.value || {}}
                navigationDispatch={navigationDispatch}
                contentWidth={`${settings.content_width}%`}
                contentTop={`${settings.content_top}%`}
                contentLeft={`${settings.content_left}%`}
                highlightColor={settings.highlightColor}
            />
            {!currentPageConfig?.hide_page_name && (
                <Subtitle highlightColor={highlightColor} groupName={groupName}>
                    {pageName}
                </Subtitle>
            )}
            <StyledSlideTitle
                size={settings.titleSize}
                hidden={!content.title || !content.title.value}
                style={useSpring({
                    opacity: 1,
                })}
            >
                <RenderContentBlock {...content.title} />
            </StyledSlideTitle>
        </SlideContainer>
    );
};

interface SlideColumnProps {
    width: string;
    paddingTop: string;
}

export default LeftContentSequencedVideo;
